<template>
  <div>
    <vs-alert v-if="pageErrors.length" color="danger">
      {{pageErrors[0]}}
    </vs-alert>
    <vs-row class="mt-5">
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"><span class="text-danger">*</span> نام </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.firstName"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"><span class="text-danger">*</span> نام خانوادگی </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.lastName"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"><span class="text-danger">*</span> نام کاربری </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.userName"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"><span class="text-danger">*</span> رمز عبور</label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.password"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"><span class="text-danger">*</span> تلفن همراه </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.cellPhoneNumber"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2">تلفن ثابت </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.homePhoneNumber"/>
      </vs-col>
      <vs-col class="mt-3" vs-xs="12" vs-lg="4" vs-sm="6">
        <label class="ml-2"> کد پستی </label>
        <vs-input class="inputx" placeholder="وارد کنید" v-model="student.postalCode"/>
      </vs-col>
    </vs-row>
    <hr class="mt-5">
    <vs-row class="mt-5">
      <vs-col vs-xs="12" vs-lg="5" vs-sm="12">
        <label class="ml-2"><span class="text-danger">*</span> آدرس منزل </label>
        <vs-textarea height="200px" class="inputx" placeholder="وارد کنید"
                     v-model="student.homeLocationText"/>
      </vs-col>
      <vs-col vs-xs="12" vs-lg="7" vs-sm="12">
        <label class="ml-2"><span class="text-danger">*</span> موقعیت مکانی آدرس منزل </label>
        <select-location :default="this.data?this.data.homeLocationLatLong:''" @change="locationChanged"></select-location>
      </vs-col>
    </vs-row>
    <div class="mt-5">
      <div class="d-flex" v-if="$store.state.AppActiveUser.role==='MODERATOR'">
        <vs-button v-if="!student.locked" @click="saveStudent"> ذخیره</vs-button>
        <vs-button :color="student.locked?'danger':'warning'" class="ml-2" icon-pack="feather"
                   :icon="student.locked?'icon-lock':'icon-unlock'" @click="lockProfile(student)">
        </vs-button>
      </div>
      <div v-else>
        <vs-alert v-if="student.locked" :active="true" icon-pack="feather">
          پروفایل شما تایید نهایی شده است .برای تغییر پروفایل باید از ادمین بخواهید قفل پروفایل را باز کند
        </vs-alert>
        <div class="d-flex" v-else>
          <vs-button @click="saveStudent"> ذخیره</vs-button>
          <vs-button color="warning" class="ml-2" icon-pack="feather" icon="icon-lock"
                     @click="approveProfileVisible = true">تایید نهایی
          </vs-button>
        </div>
      </div>


    </div>
    <vs-popup title="تایید نهایی پروفایل" :active.sync="approveProfileVisible">
      <vs-alert style="height: 60px" class="my-3" color="danger">در صورت تایید نهایی پروفایل شما قفل می شود. در این صورت
        باید از ادمین بخواهید قفل پروفایل را باز کند. آیا
        ادامه می دهید؟
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col flex-1" id="account-info-col-1">
          <table>
            <tr>
              <td class="font-semibold ">نام</td>
              <td class="pl-5" v-text="student.firstName"></td>
            </tr>
            <tr>
              <td class="font-semibold">نام خانوادگی</td>
              <td class="pl-5">{{ student.lastName }}</td>
            </tr>
            <tr>
              <td class="font-semibold">نام کاربری</td>
              <td class="pl-5">{{ student.userName }}</td>
            </tr>
          </table>
        </div>
        <div class="vx-col flex-1 mt-4" id="account-info-col-2">
          <table>
            <tr>
              <td class="font-semibold">موبایل</td>
              <td class="pl-5">{{ student.cellPhoneNumber }}</td>
            </tr>
            <tr>
              <td class="font-semibold">تلفن ثابت</td>
              <td class="pl-5">{{ student.homePhoneNumber || '-----------' }}</td>
            </tr>
            <tr>
              <td class="font-semibold">آدرس</td>
              <td class="pl-5">{{ student.homeLocationText }}</td>
            </tr>
          </table>
        </div>
      </div>
      <show-location v-if="approveProfileVisible" :default="student.homeLocationLatLong"></show-location>
      <div class="mt-3">
        <vs-button @click="lockProfile(student)">ادامه</vs-button>
        <vs-button class="ml-2" @click="approveProfileVisible=false" type="flat" color="dark">انصراف</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

  import SelectLocation from "../../components/map/SelectLocation";
  import ShowLocation from "../../components/map/ShowLocation";
  export default {
    name: "FormStudent",
    components: {ShowLocation, SelectLocation},
    mounted() {
      if (this.data) {
        this.student = Object.assign({}, this.data)
      }
    },
    data() {
      return {
        student: {
          firstName: '',
          lastName: '',
          userName: '',
          locked: '',
          cellPhoneNumber: '',
          homePhoneNumber: '',
          homeLocationText: '',
          homeLocationLatLong: '',
          password: '',
          postalCode: '',
          groups: []
        },
        pageErrors: [],
        approveProfileVisible: false
      }
    },
    methods: {
      locationChanged(val) {
        this.student.homeLocationLatLong = val
      },
      saveStudent() {
        if (this.validateUser(this.student))
          this.$emit('save', this.student)
      },
      validateUser(student) {

        if (!student.firstName || !student.lastName || !student.cellPhoneNumber || !student.userName || !student.password || !student.homeLocationText) {
          this.pageErrors = ["لطفا فیلد های اجباری را پر کنید"]
          return false
        }
        if (!student.homeLocationLatLong) {
          this.pageErrors = ["موقعیت مکانی آدرس دانش آموز را روی نقشه مشخص کنید"]
          return false
        }
        if (this.$store.state.students.length && !student.id) {
          const usernameExist = this.$store.state.students.find(i => {
            return i.firstName === student.firstName && i.lastName === student.lastName
          })
          if (usernameExist) {
            if (!confirm('دانش آموز با این نام قبلا اضافه شده است. آیا مطمئن هستید؟'))
              return false
          }
        }
        this.pageErrors = []
        return true

      },
      lockProfile(user) {
        this.$http.post('user/lock',
          {
            requester: this.$store.getters.userCredentials,
            request: {userIds: [user.id], lock: Number(!user.locked)}
          }
        ).then(res => {
          if (res.data.result) {
            user.locked = Number(!user.locked)
            this.approveProfileVisible = false
            this.$emit('lock', user)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    props: {
      data: [String, Object]
    }

  }
</script>

<style>

</style>

<style scoped>
  .vs-input {
    width: auto !important;
    padding: 0 5px;
  }
</style>
